"use client";

import { useRef } from "react";
import { HardHat, ShieldCheck, Wind, Award } from "lucide-react";
import gsap from "gsap";
import { useGSAP } from "@gsap/react";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(useGSAP, ScrollTrigger);
const features = [{
  icon: HardHat,
  title: "Vetted Pros",
  description: "Independent contractors in the Handy Heroes network are screened so you connect with dependable local service providers."
}, {
  icon: ShieldCheck,
  title: "Quality Network",
  description: "We maintain network standards for responsiveness, professional communication, and trade practices across the Atlanta area."
}, {
  icon: Wind,
  title: "Fast Matching",
  description: "Our system connects your service request directly with available local appliance specialists ready to discuss your repair."
}, {
  icon: Award,
  title: "Transparent Communication",
  description: "Every contractor provides clear diagnostic findings and their own repair quote directly to you before beginning work."
}];
export default function Valuepropositiongrid() {
  const container = useRef<HTMLDivElement>(null);
  useGSAP(() => {
    const el = container.current;
    if (!el) return;
    const mm = gsap.matchMedia();
    mm.add("(prefers-reduced-motion: no-preference)", () => {
      gsap.set(".intro-item", {
        y: 16
      });
      gsap.to(".intro-item", {
        opacity: 1,
        y: 0,
        duration: 0.5,
        ease: "power2.out",
        stagger: 0.12,
        scrollTrigger: {
          trigger: el,
          start: "top 85%",
          once: true
        }
      });
      gsap.set(".feature-item", {
        y: 16
      });
      gsap.to(".feature-item", {
        opacity: 1,
        y: 0,
        duration: 0.5,
        ease: "power2.out",
        stagger: 0.1,
        scrollTrigger: {
          trigger: ".feature-grid",
          start: "top 85%",
          once: true
        }
      });
    });
    mm.add("(prefers-reduced-motion: reduce)", () => {
      gsap.set([".intro-item", ".feature-item"], {
        opacity: 1,
        y: 0
      });
    });
    const refresh = () => ScrollTrigger.refresh();
    requestAnimationFrame(refresh);
    if (document.readyState === "complete") refresh();else window.addEventListener("load", refresh, {
      once: true
    });
    document.fonts?.ready.then(refresh);
  }, {
    scope: container
  });
  return <section data-section-id="32535" id="valuepropositiongrid" data-nav="light" className="bg-background text-foreground py-28 md:py-40">
      <div ref={container} className="mx-auto max-w-[1440px] px-8 md:px-14 lg:px-20">
        <div className="grid grid-cols-12">
          {}
          <div className="col-span-12 lg:col-span-7 mb-20">
            <div className="intro-item flex items-center gap-3 mb-6" style={{
            opacity: 0
          }}>
              <span aria-hidden="true" className="block h-3 w-px" style={{
              backgroundColor: "var(--primary)"
            }} />
              <span className="text-xs md:text-sm font-sans font-semibold uppercase" style={{
              color: "var(--primary)",
              letterSpacing: "0.18em",
              lineHeight: 1
            }}>
                The Handy Heroes Promise
              </span>
              <span aria-hidden="true" className="block h-3 w-px" style={{
              backgroundColor: "var(--primary)"
            }} />
            </div>

            <h2 className="intro-item font-serif font-bold uppercase text-foreground" style={{
            opacity: 0,
            fontSize: "clamp(2.75rem, 6vw, 5.5rem)",
            letterSpacing: "-0.005em",
            lineHeight: 0.92
          }}>
              Trusted pros. Quality results.
            </h2>

            <p className="intro-item font-default text-muted-foreground max-w-2xl mt-6" style={{
            opacity: 0,
            fontSize: "clamp(1.0625rem, 1.15vw, 1.25rem)",
            lineHeight: 1.55,
            letterSpacing: "-0.005em"
          }}>
              Handy Heroes connects Atlanta-area homeowners with independent local trade specialists. From kitchen refrigeration to laundry equipment, our platform helps you find the right local pro for your repair needs.
            </p>
          </div>
        </div>

        {}
        <div className="feature-grid grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-x-10 gap-y-10 md:gap-y-14">
          {features.map((feature, i) => {
          const Icon = feature.icon;
          return <div key={i} data-index={i} className="feature-item" style={{
            opacity: 0
          }}>
                <Icon className="text-foreground" size={32} strokeWidth={1.5} aria-hidden="true" />
                <div aria-hidden="true" className="mt-5 h-[2px] w-6" style={{
              backgroundColor: "var(--primary)"
            }} />
                <h3 className="mt-5 font-sans font-semibold uppercase text-foreground" style={{
              fontSize: "clamp(1rem, 1.1vw, 1.125rem)",
              letterSpacing: "0.02em",
              lineHeight: 1.25
            }}>
                  {feature.title}
                </h3>
                <p className="mt-3 font-default text-muted-foreground" style={{
              fontSize: "0.9375rem",
              lineHeight: 1.6
            }}>
                  {feature.description}
                </p>
              </div>;
        })}
        </div>
      </div>
    </section>;
}